<template>
  <div>
    <!-- Titlebar
================================================== -->
    <div id="titlebar" class="gradient">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h2>404 Not Found</h2>

            <!-- Breadcrumbs -->
            <nav id="breadcrumbs" class="dark">
              <ul>
                <li><router-link tag="a" to="/" href="#">Home</router-link></li>
                <li>404 Not Found</li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>

    <!-- Page Content
================================================== -->
    <!-- Container -->
    <div class="container">
      <div class="row">
        <div class="col-xl-12">
          <section id="not-found" class="center margin-top-50 margin-bottom-25">
            <h2>404 <i class="icon-line-awesome-question-circle"></i></h2>
            <p>We're sorry, but the page you were looking for doesn't exist.</p>
            <p>Not to worry, why don't you try one of these helpful links instead</p>
          </section>
          <div class="row d-flex justify-content-center">
            <router-link tag="a" to="/" class="button ripple-effect mr-2">Home</router-link>
            <router-link tag="a" to="/projects" class="button ripple-effect">Jobs</router-link>
          </div>
        </div>
      </div>
    </div>
    <!-- Container / End -->

    <!-- Spacer -->
    <div class="margin-top-70"></div>
    <!-- Spacer / End-->
  </div>
</template>

<script>
  export default {
    name: 'NotFound',
  };
</script>

<style></style>
